// extracted by mini-css-extract-plugin
export default {"error":"integration_error__8NMpn"};